export const LANGUAGE_GETLANGUAGES = 'LANGUAGE_GETLANGUAGES';
export const LANGUAGE_GETFIELDS = 'LANGUAGE_GETFIELDS';
export const LANGUAGE_FETCHING = 'LANGUAGE_FETCHING';
export const LANGUAGE_FETCH_ERROR = 'LANGUAGE_FETCH_ERROR';
export const LANGUAGE_SAVEFIELDS = 'LANGUAGE_SAVEFIELDS';
export const LANGUAGE_SETLANGUAGE = 'LANGUAGE_SETLANGUAGE';
export const LANGUAGE_SETSUCCESS = 'LANGUAGE_SETSUCCESS';
export const LANGUAGE_RESETSUCCESS = 'LANGUAGE_RESETSUCCESS';



// WEBPACK FOOTER //
// ./src/pages/languagesetup/state/types.js